import React from 'react';
import styled, { css } from 'styled-components';
import { Link, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, firstImageProperty } from '@shapeable/utils';
import { filter } from 'lodash';
import { EntityCardProps, EntityCardDefaultProps, EntityCard, EntityImage, LinkButton, useLang } from '@shapeable/ui';
import { ChevronRightThinIconGlyph, useIcon } from '@shapeable/icons';
const cls = classNames('trend-card');

// -------- Types -------->

// -------- Props -------->

export type LinkCardProps = EntityCardProps & { 
};

export const LinkCardDefaultProps: Omit<LinkCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  useEntityColorForBackground: true,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(5)};
    && {
      outline: none !important;
      box-shadow: none !important;

      &:hover {
        box-shadow: none !important;
      }

      .shp--entity-card__border,
      .shp--entity-card__container {
        border-radius: ${theme.UNIT(3)};
        img {
          border-radius: ${theme.UNIT(2)};
        }
      }
    }

  `,
  tablet: css`

  `,
});

const LearnMoreButtonStyles = breakpoints({
  base: css`
    max-width: fit-content;
    border-radius: ${theme.UNIT(5)};
    ${theme.TRANSITION('box-shadow', 'scale')};

    &:hover {
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
      scale: 1.01;
    }

    &:active {
      scale: 0.99;
    }
  `,
});

// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    LearnMoreButton: styled(LinkButton)`${LearnMoreButtonStyles}`,
};

export const LinkCard: Shapeable.FC<LinkCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  const t = useLang();

  const { url, color, label, icon } = entity || {};

  const Icon = useIcon(entity?.icon?.component);

  const image = firstImageProperty(entity, filter(['image', 'openGraph.image.thumbnails.card', 'banner.thumbnails', 'banner.image' ]))

  const entityImageAugment: Link = {
    ...entity,
    openGraph: {
      id: 'og-' + entity?.id,
      image: image,
    },
  };

  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  };

  return (
    <My.Container 
      {...cardProps}
      className={cls.name(className)}
      showExternalLink={false}
      colors={{ background: 'light' }}
      showColorStrip={false}
      showTypeHeader={false}
      showDescription
      showDescriptionDivider={false}
      showImage={false}
      useLink={false}
      entity={entityImageAugment} 
      head={
        <EntityImage entity={entityImageAugment} />
      }
      foot={
        <My.LearnMoreButton
          href={url}
          onClick={handleScrollToTop}
          colors={{ fill: 'light', background: 'primary', text: 'light', border: 'primary' }}
          variant='slim'
          borderStyle='solid'
          shape='rounded'
          icon={ChevronRightThinIconGlyph}
        >
          {label || t('Learn More')}
        </My.LearnMoreButton>
      }
    />
  )
};

LinkCard.defaultProps = LinkCardDefaultProps;
LinkCard.cls = cls;